<template>
  <div class="form__field">
    <a
      class="mod mod--style-normal mod--theme--primary mod--size--14 mod--weight--400"
      style="cursor: pointer"
      @click="e => $emit('click', e)"
      v-html="label"
    ></a>
  </div>
</template>

<script>
export default {
  props: {
    label: String
  }
};
</script>
